import { jsx, css } from '@emotion/react';
import MediaObject from '../oc-media-object'
import CTA from '../oc-cta'
import { connectLocation } from '../../location/LocationConnectors'
import getExtension from '../utilities/file-extension';
import RichText from "../oc-rich-text"
import Section from './oc-section';
// TODO - is this insulation specific?
const PLACEHOLDER_IMAGE = 'https://imagecdn.owenscorning.com/ocimages/image/upload/v1608574907/insulation/pdp/placeholder-doc.png'

const styles = css`
  .ebooks {
    display: flex;
    flex-dirextion: row;
    flex-wrap: wrap;
    width: 80%;
    margin: 0 10%;

    .ebook {
      width: 100%%;
    }

    .oc-media-object img {
      width: 170px;
      height: 214px;

      @media (max-width: 1199px) {
        width: 97px;
        height: 120px;
      }
    }

    @media (max-width: 767px) {
      margin: 0 0;
      width: 100%;
    }
  }
`

const EbooksAndGuides = connectLocation(({ t, ebooks, heading, anchor, className }) => (
  <Section anchor={anchor} className="oc-ebooks-and-guides" css={styles} className={className}>
    <h2><RichText content={heading}/></h2>
    <div className="ebooks">
      {ebooks.map(({ uid, proper_name, description, images, documents, link = {} }) => {
        const docLink = !!documents ? documents.link[0] : link;
        const url = docLink.id ? docLink.url : docLink.value

        // Ebook link data from MDMS may contain a "value", which is used here
        // for the CTA text if it is present. If the ebook link data does not have a "value",
        // use the "download" translation.
        const cta = docLink.id ? docLink.value : t('components.oc-ebooks-and-guides.download')

        return (
          <div className="ebook" key={uid}>
            <MediaObject img={images?.url || images.image?.url || PLACEHOLDER_IMAGE} alt={proper_name}>
              <h6><RichText content={proper_name}/></h6>
              <p><RichText content={description.value}/></p>
              <CTA
                href={url}
                data-track="file-download"
                data-track-file-type={getExtension(url)}
                data-track-file-name={docLink.title || proper_name}
                data-track-doc-type={docLink.category || 'eBook'}
                data-track-element-location="main section CTA"
                target="_blank"
              >
                {cta}
              </CTA>
            </MediaObject>
          </div>
        )
      })}
    </div>
  </Section>
))

EbooksAndGuides.WrappedComponent.displayName = 'EbooksAndGuides'

export default EbooksAndGuides
